import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// APIs
import { webapiApi } from './api/webapiApi';

// Slices
import authReducer from './slices/authSlice';
import tenantReducer from './slices/tenantSlice';
import uiReducer from './slices/uiSlice';
import pendingCompletionsReducer from './slices/pendingCompletionsSlice';
import createInboundReducer from './slices/createInboundSlice';
import createOutboundReducer from './slices/createOutboundSlice';
import createRoadTransportReducer from './slices/createRoadTransportSlice';
import userProfileReducer from './slices/userProfileSlice';

/**
 * Create and configure the Redux store
 * Uses factory pattern for Next.js App Router SSR compatibility
 */
export const makeStore = () => {
  const store = configureStore({
    reducer: {
      // State slices
      auth: authReducer,
      tenant: tenantReducer,
      ui: uiReducer,
      pendingCompletions: pendingCompletionsReducer,
      createInbound: createInboundReducer,
      createOutbound: createOutboundReducer,
      createRoadTransport: createRoadTransportReducer,
      userProfile: userProfileReducer,

      // RTK Query APIs
      [webapiApi.reducerPath]: webapiApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(webapiApi.middleware),
  });

  // Enable refetchOnFocus and refetchOnReconnect behaviors
  setupListeners(store.dispatch);

  return store;
};

// Type definitions
export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

// Re-export commonly used items
export * from './slices';
export * from './api';

